import { render, staticRenderFns } from "./AppMetricCard.vue?vue&type=template&id=6364326f&scoped=true&"
import script from "./AppMetricCard.vue?vue&type=script&lang=ts&"
export * from "./AppMetricCard.vue?vue&type=script&lang=ts&"
import style0 from "./AppMetricCard.vue?vue&type=style&index=0&id=6364326f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6364326f",
  null
  
)

export default component.exports